import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountService } from '../account.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    endpoint: string;
    constructor(private accountService: AccountService) {
        this.endpoint = environment.ResourcePolpaico
     }

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const user = this.accountService.userValue;
  const isLoggedIn = user && user.KEY;
  const isApiUrl = request.url.startsWith(this.endpoint);
  const isEncuesta = request.url.includes('mx_set_satisfaccion.aspx');

  if (isLoggedIn && isApiUrl && !isEncuesta) {
    request = request.clone({
      setHeaders: {
        Key: `${user.KEY}`
      }
    });
  }

  return next.handle(request);
}

}